import { SkyPose } from './sky-coach-state.service';

/** Hold clip after a situation emotion finishes. */
export type SkyHoldClip = 'rest';

/** Idle flourishes; combinable because keyframes match situation poses. */
export type SkyIdleFlourish = 'fly' | 'whistle' | 'sunglass';

export function skyPoseImageUrl(pose: SkyPose): string {
  return `./assets/sky/sky-${pose}.png?v=6`;
}

/** Convention: `public/assets/sky/animations/sky-{pose}.json` */
export function skyPoseAnimationUrl(pose: SkyPose): string {
  return `./assets/sky/animations/sky-${pose}.json`;
}

/** Original voice track exported from the matching source MP4. */
export function skyPoseAudioUrl(pose: SkyPose): string {
  return `./assets/sky/audio/sky-${pose}.m4a`;
}

export function skyHoldAnimationUrl(clip: SkyHoldClip = 'rest'): string {
  return `./assets/sky/animations/sky-${clip}.json`;
}

export function skyIdleAnimationUrl(flourish: SkyIdleFlourish): string {
  return `./assets/sky/animations/sky-${flourish}.json`;
}

/** Only the whistle flourish has a matching source audio track. */
export function skyIdleAudioUrl(flourish: SkyIdleFlourish): string | null {
  return flourish === 'whistle' ? './assets/sky/audio/sky-whistle.m4a' : null;
}

/** Idle is entertainment on the dashboard; allowed for every situation pose. */
export function skyAllowsIdle(_pose: SkyPose): boolean {
  return true;
}

export function skyShouldSettleToRest(_pose: SkyPose): boolean {
  return true;
}

/** Idle clips weighted by mood; still allowed on concerned (e.g. trial expired). */
export function skyIdleCandidates(pose: SkyPose): SkyIdleFlourish[] {
  switch (pose) {
    case 'proud':
    case 'excited':
      return ['whistle', 'sunglass', 'fly'];
    case 'encouraging':
    case 'ready':
    case 'welcome':
      return ['fly', 'sunglass', 'whistle'];
    case 'concerned':
    case 'confused':
    case 'thinking':
    case 'focused':
      return ['fly', 'whistle', 'sunglass'];
    default:
      return ['fly', 'whistle', 'sunglass'];
  }
}

export function pickSkyIdleFlourish(pose: SkyPose): SkyIdleFlourish | null {
  const candidates = skyIdleCandidates(pose);
  if (candidates.length === 0) {
    return null;
  }
  return candidates[Math.floor(Math.random() * candidates.length)];
}
